import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Redirect, Route, Switch } from 'react-router-dom'
import { withTranslation } from 'react-i18next'
import jsCookie from 'js-cookie'

import Login from '../containers/Login/Login'
import PurchaseOrderPreviews from '../containers/PurchaseOrders/Previews/show'

import authActions from '../redux/auth/actions'
import profileActions from '../redux/staffs/profiles/actions'

import CurrentStaffContainer from '../containers/CurrentStaff/CurrentStaffContainer'
import { Authorization } from '../containers/Authorization'

import DealsPage from './DealsPage'
import CustomersPage from './CustomersPage'
import OrderSummariesPage from './OrderSummariesPage'
import InquiriesPage from './InquiriesPage'
import OrdersPage from './OrdersPage'
import SalePipelinesPage from './SalePipelinesPage'
import SalesSummaryPage from './SalesSummaryPage'
import WalletSummariesPage from './WalletSummariesPage'
import CompaniesPage from './CompaniesPage'
import ProjectsPage from './ProjectsPage'
import ProfitSharingsPage from './ProfitSharingsPage'
import EventLogsPage from './EventLogsPage'
import LinePinsPage from './LinePinsPage'

import SupplierOrderReviewsPage from './SupplierOrderReviewsPage'
import SupplierOrdersPage from './SupplierOrdersPage'
import TrucksPage from './TrucksPage'
import SuppliersPage from './SuppliersPage'

import SupplierInvoicesPage from './SupplierInvoicesPage'
import OrderPaymentDetailsPage from './OrderPaymentDetailsPage'
import PaymentVouchersPage from './PaymentVouchersPage'
import TaxInvoicesPage from './TaxInvoicesPage'
import VatDocumentsPage from './VatDocumentsPage'
import BankStatementsPage from './BankStatementsPage'
import WithholdingTaxesPage from './WithholdingTaxesPage'
import ChartOfAccountsPage from './ChartOfAccountsPage'
import JournalEntryFormatsPage from './JournalEntryFormatsPage'
import JournalEntriesPage from './JournalEntriesPage'
import SupportPage from './SupportPage'

import OrderReviewsPage from './OrderReviewsPage'
import RequestItemsPage from './RequestItemsPage'
import CustomerVoicesPage from './CustomerVoicesPage'
import HighValueBasketsPage from './HighValueBasketsPage'
import LeadDistributionsPage from './LeadDistributionsPage'
import LeaveDaysPage from './LeaveDaysPage'
import SupplierPaymentsPage from './SupplierPaymentsPage'
import LoanAgreementsPage from './LoanAgreementsPage'
import EmployeeContractsPage from './EmployeeContractsPage'
import LineItemsPage from './LineItemsPage'

import ShippingRatesPage from './ShippingRatesPage'
import CustomerShippingRatesPage from './CustomerShippingRatesPage'
import StaffsPage from './StaffsPage'
import TicketsPage from './TicketsPage'

const { getToken } = authActions
const { fetchCurrentStaffProfile } = profileActions

class RootContainer extends Component {
    componentDidMount () {
        const { fetchCurrentStaffProfile, getToken } = this.props

        getToken()
        fetchCurrentStaffProfile()
    }

    renderHome = () =>{
        const { currentStaff, isCurrentStaffA } = this.props

        if (!currentStaff.size) return null

        if (isCurrentStaffA('call_center')) return <Redirect to="/customers" />

        return <Redirect to="/deals" />
    }

    renderContent () {
      const { match } = this.props
      const path = match.params[0] ? `${match.url}` : ''

      return (
        <div id='main_content'>
          <Switch>
            <Route path={`${path}/`} exact>
                {this.renderHome()}
            </Route>

            {/* Customer & Sale */}
            <Route path={`${path}/customers`} component={CustomersPage} />
            <Route path={`${path}/projects`} component={ProjectsPage} />
            <Route path={`${path}/tickets`} component={TicketsPage} />
            <Route path={`${path}/shipping_rates`} component={ShippingRatesPage} />

            <Authorization notAllowedRoles={['call_center']}>
                {/* Customer & Sale */}
                <Route path={`${path}/support`} component={SupportPage} />
                <Route path={`${path}/deals`} component={DealsPage} />
                <Route path={`${path}/lead_distributions`} component={LeadDistributionsPage} />
                <Route path={`${path}/high_value_baskets`} component={HighValueBasketsPage} />
                <Route path={`${path}/line_items`} component={LineItemsPage} />
                <Route path={`${path}/order_summaries`} component={OrderSummariesPage} />
                <Route path={`${path}/inquiries`} component={InquiriesPage} />
                <Route path={`${path}/orders`} component={OrdersPage} />
                <Route path={`${path}/sale_pipelines`} component={SalePipelinesPage} />
                <Route path={`${path}/sales_summary`} component={SalesSummaryPage} />
                <Route path={`${path}/wallet_summaries`} component={WalletSummariesPage} />
                <Route path={`${path}/companies`} component={CompaniesPage} />
                <Route path={`${path}/profit_sharings`} component={ProfitSharingsPage} />
                <Route path={`${path}/event_logs`} component={EventLogsPage} />
                <Route path={`${path}/line_pins`} component={LinePinsPage} />

                {/* Vendor */}
                <Route path={`${path}/supplier_order_reviews`} component={SupplierOrderReviewsPage} />
                <Route path={`${path}/supplier_orders`} component={SupplierOrdersPage} />
                <Route path={`${path}/trucks`} component={TrucksPage} />
                <Route path={`${path}/suppliers`} component={SuppliersPage} />

                {/* Account */}
                <Route path={`${path}/supplier_invoices`} component={SupplierInvoicesPage} />
                <Route path={`${path}/order_payment_details`} component={OrderPaymentDetailsPage} />
                <Route path={`${path}/payment_vouchers`} component={PaymentVouchersPage} />
                <Route path={`${path}/supplier_payments`} component={SupplierPaymentsPage} />
                <Route path={`${path}/tax_invoices`} component={TaxInvoicesPage} />
                <Route path={`${path}/vat_documents`} component={VatDocumentsPage} />
                <Route path={`${path}/bank_statements`} component={BankStatementsPage} />
                <Route path={`${path}/withholding_taxes`} component={WithholdingTaxesPage} />
                <Route path={`${path}/chart_of_accounts`} component={ChartOfAccountsPage} />
                <Route path={`${path}/journal_entry_formats`} component={JournalEntryFormatsPage} />
                <Route path={`${path}/journal_entries`} component={JournalEntriesPage} />
                <Route path={`${path}/loan_agreements`} component={LoanAgreementsPage} />

                {/* Feedback */}
                <Route path={`${path}/order_reviews`} component={OrderReviewsPage} />
                <Route path={`${path}/customer_voices`} component={CustomerVoicesPage} />
                <Route path={`${path}/request_items`} component={RequestItemsPage} />

                {/* HR */}
                <Route path={`${path}/leave_days`} component={LeaveDaysPage} />
                <Route path={`${path}/employee_contracts`} component={EmployeeContractsPage} />

                {/* Setting */}
                <Route path={`${path}/customer_shipping_rates`} component={CustomerShippingRatesPage} />
                <Route path={`${path}/staffs`} component={StaffsPage} />

                {/* Extra */}
                <Route path={`${path}/purchase_orders/:ref_code/previews`} component={PurchaseOrderPreviews} />
            </Authorization>
          </Switch>
        </div>
      )
    }

    render () {
        return jsCookie.get('token') ? this.renderContent() : <Login />
    }
}

const mapStateToProps = (state) => ({
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        fetchCurrentStaffProfile,
        getToken
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('notifications')(CurrentStaffContainer(RootContainer)))
